/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { ImportContainerRequest } from '../model'
/**
 * ContainersApi - axios parameter creator
 */
export const ContainersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {Array<ImportContainerRequest>} [importContainerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importBatch: async (
      importContainerRequest?: Array<ImportContainerRequest>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Containers/ImportBatch`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        importContainerRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ContainersApi - functional programming interface
 */
export const ContainersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ContainersApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {Array<ImportContainerRequest>} [importContainerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async importBatch(
      importContainerRequest?: Array<ImportContainerRequest>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.importBatch(
        importContainerRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ContainersApi.importBatch']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ContainersApi - factory interface
 */
export const ContainersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ContainersApiFp(configuration)
  return {
    /**
     *
     * @param {Array<ImportContainerRequest>} [importContainerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importBatch(
      importContainerRequest?: Array<ImportContainerRequest>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .importBatch(importContainerRequest, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * ContainersApi - object-oriented interface
 */
export class ContainersApi extends BaseAPI {
  /**
   *
   * @param {Array<ImportContainerRequest>} [importContainerRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public importBatch(
    importContainerRequest?: Array<ImportContainerRequest>,
    options?: RawAxiosRequestConfig,
  ) {
    return ContainersApiFp(this.configuration)
      .importBatch(importContainerRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
